var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/**
 * Fold / hero - template-1 variant: a single jackpot card (logo + details + next draw + play),
 * no subscribe flow or desktop-lottery layer (those are template-7's fold). Lottery data + the
 * featured top-banner lottery live on the shell (host).
 */
var FoldT1 = /** @class */ (function (_super) {
    __extends(FoldT1, _super);
    function FoldT1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FoldT1;
}(RenderBlock));
export { FoldT1 };
